// import { ReactComponent as ArrowGradient } from "../icons/arro-gradient.svg";
import ArrowGradient from "../icons/ArroGradient"
import BlueRTArrow from "../icons/BlueRTArrow";
// import { ReactComponent as BtnPlay } from '../icons/btn-play.svg'
import BtnPlay from "../New-theme/icons/BtnPlay";
import Logo from "../icons/logo.svg";
import CallGradi from "./call-gradient.svg";
import Location from "./location.svg";
// import Facebook from './facebook.svg'
// import Youtube from './youtube.svg'
// import Instagram from './insta-icon.svg'
// import Linkedin from './linkedin.svg'
// import XIcon from './x-icon.svg'
import Search from "./searchicon.svg";
import Facebook from "./fb-blu.svg";
import Youtube from "./yt-blu.svg";
import Instagram from "./insta-blu.svg";
import Linkedin from "./linkedin-blu.svg";
import XIcon from "./x-blu.svg";
import Helpline from "./helpline-icon.svg";
import EmgIcon from "./emg-icon.svg";
import Email from "./email.svg";
import BannerDivider from "./banner-devider.svg";
import  ArrowRightTab  from "./ArrowRightTab";

import Call24 from "./call-24";
import StrokeBrain from "./CampaignPageicons/StrokeBrain";
import Epilepsy from "./CampaignPageicons/Epilepsy";
import CerebralPalsy from "./CampaignPageicons/CerebralPalsy";
import Hydrocephalus from "./CampaignPageicons/Hydrocephalus";
import PeripheralNerveDisorder from "./CampaignPageicons/PeripheralDisorder";
import SleepDisorder from "./CampaignPageicons/SleepDisorders";
import TrustedTeam from "./CampaignPageicons/trusted-team";
import Worlclasscare from "./CampaignPageicons/world-class-care";
import InnovativeTreat from "./CampaignPageicons/innovative-treatment";
import LegacyTrust from "./CampaignPageicons/legacy-trust";
import Appendicitis from "./CampaignPageicons/Appendicitis";
import Gallstones from "./CampaignPageicons/Gallstones";
import Hernias from "./CampaignPageicons/Hernias";
import Colorectalconditions from "./CampaignPageicons/Colorectalconditions";
import TongueTie from "./CampaignPageicons/TongueTie";
import StaplerCircumcision from "./CampaignPageicons/StaplerCircumcision";
import BlueStar from "./CampaignPageicons/blue-str";
import WhiteStth from "./CampaignPageicons/white-stth";
import PersonThreestar from "./CampaignPageicons/person-threestar";
import NabhWhite from "./CampaignPageicons/nabh-white";

export {
  Logo,
  CallGradi,
  Location,
  ArrowGradient,
  Facebook,
  BtnPlay,
  Helpline,
  Instagram,
  Linkedin,
  XIcon,
  EmgIcon,
  Youtube,
  Email,
  BannerDivider,
  BlueRTArrow,
  ArrowRightTab,
  Call24,
  StrokeBrain,
  Epilepsy,
  CerebralPalsy,
  Hydrocephalus,
  PeripheralNerveDisorder,
  SleepDisorder,
  TrustedTeam,
  Worlclasscare,
  InnovativeTreat,
  LegacyTrust,
  Appendicitis,
  Gallstones,
  Hernias,
  Colorectalconditions,
  TongueTie,
  StaplerCircumcision,
  BlueStar,
  WhiteStth,
  PersonThreestar,
  NabhWhite,
  Search,
};
